import { render, staticRenderFns } from "./ImproveInfo.vue?vue&type=template&id=3b0bc376&scoped=true&"
import script from "./ImproveInfo.vue?vue&type=script&lang=js&"
export * from "./ImproveInfo.vue?vue&type=script&lang=js&"
import style0 from "./ImproveInfo.vue?vue&type=style&index=0&id=3b0bc376&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0bc376",
  null
  
)

export default component.exports